var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"frame-wrapper"},[(_vm.template)?_c('Editor'):_c('ProductUnavailable')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }